import React, { useState, useEffect, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { ScholarshipsProvider } from '../contexts/ScholarshipsContext';

interface LazyScholarshipsProviderProps {
  children: ReactNode;
}

const LazyScholarshipsProvider: React.FC<LazyScholarshipsProviderProps> = ({ children }) => {
  const [shouldLoadScholarships, setShouldLoadScholarships] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Check if we're on a scholarship-related page
    const isScholarshipPage = location.pathname.includes('/scholarships');
    
    if (isScholarshipPage) {
      // Load immediately if on scholarship page
      console.log('🔄 App: Loading ScholarshipsContext for scholarship page...');
      setShouldLoadScholarships(true);
    } else {
      // Lazy load scholarships context after dashboard is loaded
      const timer = setTimeout(() => {
        console.log('🔄 App: Lazy loading ScholarshipsContext...');
        setShouldLoadScholarships(true);
      }, 1000); // 1 second delay after app loads

      return () => clearTimeout(timer);
    }
  }, [location.pathname]);

  if (!shouldLoadScholarships) {
    // Return children without ScholarshipsProvider during initial load
    return <>{children}</>;
  }

  // Return children wrapped in ScholarshipsProvider after delay
  return <ScholarshipsProvider>{children}</ScholarshipsProvider>;
};

export default LazyScholarshipsProvider;
